type Callback = (data: any) => void | Promise<void>

export class Sse {
  private static eventSource: EventSource | null = null
  private static callbacks = new Map<string, Callback[]>()

  static connect(uid?: string) {
    if (!Sse.eventSource) {
      const _uid = sessionStorage.getItem('fnm.auth.user.id')

      Sse.eventSource = new EventSource(
        `${process.env.VUE_APP_API_BASE_URL}/events?uid=${_uid ?? uid}`
      )

      console.log('Event source setup')

      Sse.eventSource.onmessage = event => {
        const message = JSON.parse(event.data) as { event: string; data: any }
        console.log({ message })
        Sse.callbacks.forEach((callbacks, key) => {
          if (message.event === key) {
            for (const callback of callbacks) {
              callback(message.data)
            }
          }
        })
      }
    }
  }

  static listen(event: string, cb: Callback) {
    const callbacks = Sse.callbacks.get(event) ?? []
    Sse.callbacks.set(event, [...callbacks, cb])
  }
}
